<template>
  <van-popup v-model="show" position="bottom" class="sku-action-wrap" @closed="closed">

    <section class="sku-action">
      <component :is="skuHead" :data="headData"/>
      <Sku :data="skuData" :detail="detail" v-model="count" @change="changeSku"/>
      <footer class="sku_foot">
        <van-button @click="confirm('addCart')" color="#ff6400">加入购物车</van-button>
        <van-button @click="confirm('buyNow')" color="#f44">立即购买</van-button>
      </footer>
    </section>

  </van-popup>
</template>

<script>
  import {Toast} from 'vant';
  import GoodsHead from './GoodsHead';
  import Sku from './Sku.vue';

  export default {
	name: 'SkuAction',
	props: {},
	components: {Sku},
	data() {
	  return {
		show: false,
		detail: {},
		skuData: null,
		count: 0,
		selectedSku: null
	  };
	},
	created() {
	},
	methods: {
	  confirm(type) {
		if (this.skuData && !this.selectedSku) {
		  return Toast.fail('请先选择规格!');
		}
		if (this.count <= 0) {
		  return Toast.fail('请先添加数量!');
		}

		if (this.detail.availablePoint < this.detail.tradePoint) {
		  return Toast.fail('您的积分不足!');
		}

		this.resolve({
		  success: true,
		  data: {
			type,
			sku_guid: this.selectedSku ? this.selectedSku.skuGuid : null,
			count: this.count
		  }
		});
		this.show = false;
	  },
	  cancel() {
		this.resolve({
		  success: false,
		  data: {}
		});
		this.show = false;
	  },
	  closed() {
		this.cancel();
		this.$destroy();
	  },
	  changeSku(data) {
		this.selectedSku = data;
	  }
	},
	computed: {
	  skuHead() {
		if (this.customSkuHead) return this.customSkuHead;
		return GoodsHead;
	  },
	  headData() {
		return {
		  title: this.detail.name,
		  trade_point: this.detail.tradePoint,
		  ...this.price,
		  image_url: this.detail.imagePath || 'https://h5.yunhuiyuan.cn/Images/ShopDiy/default_goods.png',
		};
	  },

	  price() {
		if (!this.skuData) return {
		  min_price: this.detail.mallPrice,
		  max_price: this.detail.mallPrice,
		  origin_price: this.detail.marketPrice
		};
		if (!this.selectedSku) return {
		  min_price: this.skuData.minMallPrice,
		  max_price: this.skuData.maxMallPrice,
		  origin_price: this.skuData.maxMarketPrice
		};
		return {
		  min_price: this.selectedSku.mallPrice,
		  max_price: this.selectedSku.mallPrice,
		  origin_price: this.skuData.maxMarketPrice
		};
	  }

	},
	beforeDestroy() {
	  this.$el && this.$el.remove();
	},
  };
</script>

<style lang="less" rel="stylesheet/less">

  .sku-action-wrap {
    color: @text-color-primary;
    border-radius: 8px 8px 0 0;
    overflow: hidden;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }

  .sku-action {
    min-height: 200px;
    padding-bottom: 54px;
    position: relative;

    .sku_foot {
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;

      .van-button {
        flex: 1;
        border-radius: 0;
        color: #fff;
      }
    }
  }
</style>
